import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';
import { FormattedMessage, injectIntl } from 'react-intl';

import * as _actionsJourney from '../../actions/journey1';
import * as _actionsCheckout from '../../actions/checkout';
import * as _actionsBasket from '../../actions/basket';
import * as _actionsSujet from '../../actions/sujet';
import { RootState } from '../../reducers';
import { Button, EButtonType } from '@repo/apg-ui';
import './OrderConfirmation.scss';
import * as actions from '../../actions/index';
import SpinnerV2 from '../../components/SpinnerV2';
import { getParameterByName } from '../../utils/toSearchParams';
import { ReactComponent as IconThumbsUp } from '../../assets/icons/thumbsUp.svg';
import { getPathname } from '../../utils/paths';
import { trackPaymentJourneyCompleted } from '../../utils/journeyTracking';
import { useNavigate } from 'react-router';
import { triggerDynamicsOnFinishOrder } from '../../utils/reloadDynamics';
import { isProd } from '../../constants/config';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

interface Props {
  actionsJourney: typeof _actionsJourney;
  actionsCheckout: typeof _actionsCheckout;
  actionsBasket: typeof _actionsBasket;
  router: any;
  intl: any;
  journey2?: boolean;
  loading: boolean;
  locales: any;
  history: any;
  possibleBookingDates: any;
  postProposals: any;
  proposals: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
  match: any;
  actionsSujet: typeof _actionsSujet;
  keycloakReady: boolean;
  dispatch: any;
}

const OrderConfirmation = (props: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isOfferte, setIsOfferte] = useState(false);
  const [campaignId, setCampaignId] = useState('');
  const [lastBookedBasketIndustry, setLastBookedBasketIndustry] = useState();
  const containers = useSelector((state: RootState) => state.app.containers);

  const navigate = useNavigate();

  const { userDataEC, intl } = props;
  const {
    userDataEC: {
      basketInfo,
      lastBookedBasketInfo,
      chosenProposal,
      campaignName,
      isBasketBooked,
      userInfo,
      isAgencyJourney,
    },
    journey2,
    actionsBasket,
    actionsCheckout,
  } = props;

  useEffect(() => {
    setIsLoading(true);

    if (props.router.location.state?.referrer.includes('checkout/accept')) {
      let acceptPayload: string = '';

      const basketPayload = `basket=${props.journey2 ? basketInfo.basket : chosenProposal.basket}`;
      if (props.router.location.state?.search) {
        acceptPayload = props.router.location.state.search + '&' + basketPayload;
      } else {
        acceptPayload = '?' + basketPayload;
      }

      props.actionsCheckout.getPostfinanceAccept(acceptPayload).then((data: unknown) => {
        // wrap() swallows backend errors, resolving with undefined or an Error instead.
        if (data && !(data instanceof Error)) {
          // PostFinance echoes the campaign number back as orderid.
          trackPaymentJourneyCompleted(new URLSearchParams(props.router.location.state?.search).get('orderid'));
        }
      });
    }

    if (!basketInfo) {
      navigate(getPathname(containers)(1));
    }

    try {
      const payload = {
        basket: props.journey2 ? basketInfo.basket : chosenProposal.basket,
        basketreference: journey2 ? basketInfo.basketreference || null : chosenProposal.basketreference,
        countgroup: 'format',
      };

      props.actionsBasket.fetchBookedBasketInfo(payload).then((res) => {
        setIsLoading(false);
        setIsOfferte(res?.category === 2 || res?.category === 3);
        setLastBookedBasketIndustry(res?.industry.name);
        setCampaignId(getParameterByName('campaignId', props.router.location.search) || null);
      });

      props.actionsJourney.getUserInfo();
      props.actionsCheckout.fetchPaymentMethods({
        basket: props.journey2 ? props.userDataEC.basketInfo.basket : props.userDataEC.chosenProposal.basket,
      });

      if (campaignName && isBasketBooked) {
        if (isProd) {
          triggerDynamicsOnFinishOrder('order_completed', userInfo?.email);
        }
        actionsCheckout.setCampaignName('');
        actionsCheckout.setIsBasketBooked(false);
        actionsBasket.clearBasketInfo();
      }
    } catch (err) {
      console.error('FE error', err);
    }
  }, []);

  const fetchCampaigns = () => {
    let payload = {
      owner: (window as any).keycloak.tokenParsed['gepard-nr'],
    };

    // @ts-expect-error owner does not exist on Payload type:
    props.actionsSujet.getCampaigns(payload);
  };

  useEffect(() => {
    fetchCampaigns();
  }, [props.keycloakReady]);

  const isShowAlternativeButtons = () => {
    return props.intl.locale === 'de' && lastBookedBasketInfo?.sujetcreationservice;
  };

  return userDataEC || isLoading ? (
    <div className='OrderConfirmation bg-white row m-0'>
      <div className='w-100'>
        <div className='d-flex flex-column justify-content-center align-items-center w-100 confirmation-title'>
          <div className='confirmation-icon d-flex justify-content-center align-items-center'>
            <IconThumbsUp />
          </div>
          <h3 className='confirmation-message w-100 p-24 mt-24 mb-4 text-center'>
            {isAgencyJourney && lastBookedBasketInfo?.category === 3 ? (
              <FormattedMessage
                id='ec.confirmation.messageAgency'
                defaultMessage='Kampagne {campaign} wurde erfolgreich reserviert.'
                values={{ campaign: campaignId ? campaignId : lastBookedBasketInfo?.name }}
              />
            ) : (
              <FormattedMessage
                id='ec.confirmation.message'
                defaultMessage='Kampagne {campaign} wurde erfolgreich gebucht.'
                values={{ campaign: campaignId ? campaignId : lastBookedBasketInfo?.name }}
              />
            )}
          </h3>
        </div>

        <div className='d-flex w-100 pb-24 confirmation-body'>
          <div className='w-100 p-0 m-0'>
            <div className='row d-flex flex-md-row justify-content-between flex-column'>
              <div className='col col-md-5'>
                <h3 className='mt-4 mb-4'>
                  <FormattedMessage id='ec.checkout.plakatanlieferung' defaultMessage='Werbemittelanlieferung' />
                  {isOfferte ? ' (Offerte)' : ''}
                </h3>

                <div className='mb-48'>
                  {lastBookedBasketInfo?.deliverydata &&
                    lastBookedBasketInfo?.deliverydata.length > 0 &&
                    lastBookedBasketInfo?.deliverydata.map(({ address, datetime, type, formatlabel, countformats }) => (
                      <div className='w-100 mb-4 font-16'>
                        <p className='fw-bold mb-3'>
                          {type === 'digital' && (
                            <FormattedMessage id='ec.checkout.anlieferungDigitalType' defaultMessage='Digital-Spots:' />
                          )}

                          {type === 'traffic' && (
                            <FormattedMessage id='ec.checkout.anlieferungTrafficType' defaultMessage='Hängekartons:' />
                          )}

                          {type === 'plakat' && (
                            <FormattedMessage id='ec.checkout.anlieferungPlakatType' defaultMessage='Plakate:' />
                          )}
                        </p>

                        <p className='mb-3 font-14 label-value mb-0 text-left'>
                          <FormattedMessage
                            id='ec.checkout.anlieferungDate'
                            defaultMessage='{label} bis am {deliveryDate}'
                            values={{
                              label:
                                type === 'digital'
                                  ? intl.formatMessage({
                                      id: 'ec.checkout.anlieferungDateDigitalLabel',
                                      defaultMessage: 'Hochladen der Spots',
                                    })
                                  : intl.formatMessage({
                                      id: 'ec.checkout.anlieferungDateGeneralLabel',
                                      defaultMessage: 'Anlieferung',
                                    }),
                              deliveryDate: format(parseISO(datetime), 'dd.MM.yyyy', {
                                locale: de,
                              }),
                            }}
                          />
                        </p>

                        <p className='mb-3 font-14 label-value mb-0 text-left'>
                          <FormattedMessage
                            id='ec.checkout.anlieferungsAddress'
                            defaultMessage='Anlieferungsadresse: {deliveryAddress}'
                            values={{ deliveryAddress: address }}
                          />
                        </p>

                        {formatlabel && <p className='fw-bold mb-3 mt-3'>{formatlabel}</p>}
                        {countformats && <p className='mb-3 font-14 label-value mb-0 text-left'>{countformats}</p>}
                      </div>
                    ))}
                </div>
                <div className='row d-flex flex-md-row justify-content-between flex-column'>
                  {!isShowAlternativeButtons() && (
                    <div className='w-100 production-service'>
                      <p className='fw-bold'>
                        <FormattedMessage
                          id='ec.checkout.productionService'
                          defaultMessage='Produktions-Service gefallig?'
                        />
                      </p>
                      <p className='mb-3 font-14 label-value'>
                        <FormattedMessage
                          id='ec.checkout.productionServiceText'
                          defaultMessage='Nutzen Sie unsere Services zu Plakatdruck und Spot-Produktion. Weitere Infos finden Sie <a>hier</a>.'
                          values={{
                            a: (chunks: any) => (
                              <Button
                                onClick={() => navigate('/dashboard')}
                                className='mt-0'
                                buttonType={EButtonType.BasicLink}
                              >
                                {chunks}
                              </Button>
                            ),
                          }}
                        />
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className='col col-md-6'>
                <h3 className='mt-4 mb-4'>
                  <FormattedMessage id='ec.checkout.summaryOfOrder' defaultMessage='Zusammenfassung Ihrer Bestellung' />
                </h3>
                <div className='d-flex align-items-center justify-content-between py-3 border-bottom border-grey-very-light font-14'>
                  <div className='font-bold'>
                    <FormattedMessage id='ec.summary.campaignNumber' defaultMessage='Kampagnen-Nr.' />
                  </div>
                  <div className='label-value padding-start text-end'>
                    <span>{lastBookedBasketInfo?.campaign} </span>
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-between py-3 border-bottom border-grey-very-light font-14'>
                  <div className='font-bold'>
                    <FormattedMessage id='ec.summary.flachen' defaultMessage='Flächen' />
                  </div>
                  <div className='label-value padding-start text-end'>
                    <span>{lastBookedBasketInfo?.totalcount} </span>
                    {lastBookedBasketInfo?.countgroups &&
                      lastBookedBasketInfo?.countgroups.map((group, idx) => {
                        return (
                          <span key={`countGroup${idx}`}>
                            | {group.count} {group.name}
                          </span>
                        );
                      })}
                  </div>
                </div>

                <div className='d-flex align-items-center justify-content-between py-3 border-bottom border-grey-very-light font-14'>
                  <div className='font-bold'>
                    <FormattedMessage id='ec.summary.zeitraum' defaultMessage='Zeitraum' />
                  </div>
                  <div className='label-value padding-start text-end'>{lastBookedBasketInfo?.date}</div>
                </div>

                <div className='d-flex align-items-center justify-content-between py-3 border-bottom border-grey-very-light font-14'>
                  <div className='font-bold'>
                    <FormattedMessage id='ec.summary.branche' defaultMessage='Branche' />
                  </div>
                  <div className='label-value padding-start text-end'>{lastBookedBasketIndustry}</div>
                </div>

                <div className='d-flex align-items-center justify-content-between py-3 font-14'>
                  <div className='font-bold'>
                    <FormattedMessage id='ec.summary.zielgebiet' defaultMessage='Zielgebiet' />
                  </div>
                  {lastBookedBasketInfo?.regions && (
                    <div className='label-value padding-start text-end'>
                      {lastBookedBasketInfo?.regions.map((region, idx) => (
                        <span className='pl-1' key={`region${idx}`}>
                          {region.name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {isShowAlternativeButtons() && (
              <div className='row d-flex flex-md-row justify-content-between flex-column mt-5 pt-5'>
                <div className='col col-md-5'>
                  <div className='w-100 production-service'>
                    <p className='fw-bold'>
                      <FormattedMessage
                        id='ec.checkout.productionServicePlakatSujet'
                        defaultMessage='Benötigen Sie ein Werbesujet?'
                      />
                    </p>
                    <p className='mb-5 font-14 label-value'>
                      <FormattedMessage
                        id='ec.checkout.productionServiceTextAboutKI'
                        defaultMessage='Wir nutzen die neuste KI-Technologie um für Sie ein einzigartiges Werbesujet zu erstellen.'
                      />
                    </p>
                    <Button
                      className='d-flex justify-content-center text-white align-items-center mt-4 font-weight-600 font-20'
                      href={lastBookedBasketInfo?.sujetcreationservice}
                      buttonType={EButtonType.FullWidth}
                    >
                      <FormattedMessage id='ec.checkout.productionServiceButton' defaultMessage='Mehr erfahren' />
                    </Button>
                  </div>
                </div>
                <div className='col col-md-6'>
                  <div className='w-100 production-service'>
                    <p className='fw-bold'>
                      <FormattedMessage
                        id='ec.checkout.productionService'
                        defaultMessage='Produktions-Service gefallig?'
                      />
                    </p>
                    <p className='mb-5 font-14 label-value'>
                      <FormattedMessage
                        id='ec.checkout.productionServiceTextAlternative'
                        defaultMessage='Nutzen Sie unsere Services zu Plakatdruck und Produktionsinformationen.'
                      />
                    </p>
                    <Button
                      onClick={() => navigate('/dashboard')}
                      className='d-flex justify-content-center align-items-center font-weight-600 font-20'
                      buttonType={EButtonType.FullWidth}
                    >
                      <FormattedMessage id='ec.checkout.productionServiceButton' defaultMessage='Mehr erfahren' />
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className='d-flex flex-column w-100 pb-24 confirmation-actions align-items-center justify-content-center'>
          <div className='view-campaign-button'>
            <Button className={'mt-0'} buttonType={EButtonType.FullWidth} onClick={() => navigate('/dashboard')}>
              {intl.formatMessage({
                id: 'ec.components.buttons.viewCampaign',
                defaultMessage: 'Ihre Kampagnen ansehen',
              })}
            </Button>
          </div>

          <div className='plan-campaign-button mt-3'>
            <Button
              className={'mt-0 text-underline'}
              buttonType={EButtonType.BasicLink}
              onClick={() => {
                if (isAgencyJourney) {
                  actionsCheckout.setCampaignName('');
                  actionsCheckout.setIsBasketBooked(false);
                  actionsBasket.clearBasketInfo();
                  navigate('/agency');
                } else {
                  navigate(getPathname(containers)(1));
                }
              }}
            >
              {intl.formatMessage({
                id: 'ec.components.buttons.planNextCampaign',
                defaultMessage: 'oder planen Sie die nächste Kampagne',
              })}
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <SpinnerV2 />
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
    router: state.router,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
    actionsCheckout: bindActionCreators(_actionsCheckout as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsSujet: bindActionCreators(_actionsSujet as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(OrderConfirmation)));
